import React from "react";

import { ColumnStyle, Steward } from "components/Common/TableStyle";

export const CDE_COLUMNS = () => [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    fixed: "left",
    width: 150,
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: 200,
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "Drafter",
    key: "drafter",
    dataIndex: "drafter",
    width: 200,
    render: row => <Steward name={row?.name} title={row?.role} />,
  },
  {
    title: "Approver",
    key: "approver",
    dataIndex: "approver",
    width: 200,
    render: row => <Steward name={row?.name} title={row?.role} />,
  },
  {
    dataIndex: "is_secured",
    key: "is_secured",
    title: "Secured CDE",
    width: 150,
    render: row => {
      if (row === "") return "No";
      else if (row === "phi") return "PHI";

      return "Business Sensitive";
    },
  },
  {
    dataIndex: "mapping_status",
    key: "mapping_status",
    title: "Mapping Status",
    width: 200,
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "# Data Source",
    key: "data_source_count",
    dataIndex: "data_source_count",
    width: 150,
    render: text => <ColumnStyle text={text} />,
  },
];
